export var TokenType;
(function (TokenType) {
    TokenType["Evm"] = "evm";
    TokenType["AssetHub"] = "assethub";
    TokenType["Stellar"] = "stellar";
    TokenType["Moonbeam"] = "moonbeam";
})(TokenType || (TokenType = {}));
export var FiatToken;
(function (FiatToken) {
    FiatToken["EURC"] = "eurc";
    FiatToken["ARS"] = "ars";
    FiatToken["BRL"] = "brl";
})(FiatToken || (FiatToken = {}));
export var AssetHubToken;
(function (AssetHubToken) {
    AssetHubToken["USDC"] = "usdc";
})(AssetHubToken || (AssetHubToken = {}));
